import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d8d0617")

_pushScopeId("data-v-7d8d0617")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "体の部位選択", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_body_parts_selector = _resolveComponent("body-parts-selector")
  const _component_carousel_item_frame = _resolveComponent("carousel-item-frame")
  const _component_carousel = _resolveComponent("carousel")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode(_component_carousel, {
        class: "carousel",
        ref: "carouselRef"
      }, {
        default: _withId(() => [
          _createVNode(_component_carousel_item_frame, null, {
            default: _withId(() => [
              _createVNode(_component_body_parts_selector, {
                direction: "front",
                selectedDirection: _ctx.selectedDirection,
                "onUpdate:selectedDirection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDirection = $event)),
                selectedBodyParts: _ctx.selectedBodyParts,
                "onUpdate:selectedBodyParts": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedBodyParts = $event)),
                existsPartsList: _ctx.existsPartsList.front
              }, null, 8, ["selectedDirection", "selectedBodyParts", "existsPartsList"])
            ]),
            _: 1
          }),
          _createVNode(_component_carousel_item_frame, null, {
            default: _withId(() => [
              _createVNode(_component_body_parts_selector, {
                direction: "left",
                selectedDirection: _ctx.selectedDirection,
                "onUpdate:selectedDirection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedDirection = $event)),
                selectedBodyParts: _ctx.selectedBodyParts,
                "onUpdate:selectedBodyParts": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedBodyParts = $event)),
                existsPartsList: _ctx.existsPartsList.left
              }, null, 8, ["selectedDirection", "selectedBodyParts", "existsPartsList"])
            ]),
            _: 1
          }),
          _createVNode(_component_carousel_item_frame, null, {
            default: _withId(() => [
              _createVNode(_component_body_parts_selector, {
                direction: "back",
                selectedDirection: _ctx.selectedDirection,
                "onUpdate:selectedDirection": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedDirection = $event)),
                selectedBodyParts: _ctx.selectedBodyParts,
                "onUpdate:selectedBodyParts": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedBodyParts = $event)),
                existsPartsList: _ctx.existsPartsList.back
              }, null, 8, ["selectedDirection", "selectedBodyParts", "existsPartsList"])
            ]),
            _: 1
          }),
          _createVNode(_component_carousel_item_frame, null, {
            default: _withId(() => [
              _createVNode(_component_body_parts_selector, {
                direction: "right",
                selectedDirection: _ctx.selectedDirection,
                "onUpdate:selectedDirection": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedDirection = $event)),
                selectedBodyParts: _ctx.selectedBodyParts,
                "onUpdate:selectedBodyParts": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedBodyParts = $event)),
                existsPartsList: _ctx.existsPartsList.right
              }, null, 8, ["selectedDirection", "selectedBodyParts", "existsPartsList"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      (!_ctx.allSet)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["parts-detail", _ctx.$mq]
          }, "赤い部分は経穴の設定がありません。 ", 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})